<template>
  <div id="app">
    <router-view  v-if="isRouterAlive"/>
  </div>
</template>
<script>
  export default {
    data(){
      return{
      }
    },
    computed:{
      isRouterAlive(){
        return this.$store.state.isRouterAlive // 用来解决路由相同不刷新问题
      }
    }
  }
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1200px;
  background: #f5f5f5;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
